export default {
    init() {
        const el = document.querySelector("#arrow-scroll-to-top");

        if(!el){
            return;
        }
        addEventListener("scroll", e=> {
            if (window.scrollY > 400) {
                el.style.opacity = 1;
                el.style.visibility = "visible";
            } else {
                el.style.opacity = 0;
                el.style.visibility = "hidden";
            }
        })
      

        el.addEventListener("click", (e) => {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        });
    },
};
